import { Component, OnInit, HostListener } from '@angular/core';
import { CompaniesService } from '../../services/companies.service';
import { Company } from '../../models/Company.model';
import { CompanyGroup } from '../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../models/CompanyGroupSearch.model";
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { CompanySearch } from '../../models/CompanySearch.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { DropDownList } from '../../models/DropDownList.model';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {

  itemsPerPage: number[] = [10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 0;

  dropDownListCompanyGroups: DropDownList[] = new Array<DropDownList>();
  selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
  dropDownCompanyGroupsSettings = {};

  companies: Company[] = null;
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companyGroupSearchModel: CompanyGroupSearch;
  commonHelper: CommonHelper = new CommonHelper();
  companySearchModel: CompanySearch;
  months;
  years;
  loading: boolean;

  constructor(private companiesService: CompaniesService,
              private localStorage: LocalStorage) { }

  async ngOnInit() {
    this.loading = true;
    this.months = this.commonHelper.listAllMonths();
    this.years = this.commonHelper.listLastYears();

    this.companySearchModel = this.localStorage.retrieve('company')?this.localStorage.retrieve('company'):new CompanySearch();
    this.companySearchModel.onlyCustomer = true;
    if(!this.companySearchModel.hasOwnProperty('companyGroup')) this.companySearchModel.companyGroup = [];

    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
    this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(true, 'Grupo de empresa', false, 'Marcar todas os grupos', 'Desmarcar todas os grupos', true,null, '');

    await this.searchCompanies(1);
    this.loading = false;
  }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchCompanies(1);
        }

    }

  async searchCompanies(page?: number) {
    this.loading = true;
    this.currentPage = page ? page : 1;
    this.companySearchModel.skip = (page - 1) * this.companySearchModel.limit;
    this.companySearchModel.onlyExternalReference = false;
    this.companySearchModel.companyGroup = this.selectedCompanyGroupsItems.map(cg => cg.id);
    this.companies = await this.companiesService.searchCompanies(this.companySearchModel);
    this.totalItems = this.companySearchModel.totalItems;
    this.localStorage.persist('company',this.companySearchModel);
    this.loading = false;
  }

  isActive(active: boolean) {
    return active ? "badge-success" : "badge-danger";
  }
  isActiveText(active: boolean) {
    return active ? "Ativo" : "Inativo";
  }

}



// WEBPACK FOOTER //
// ./src/app/views/companies/companies.component.ts